import type { TLRecord } from '@digitalsamba/tldraw';
import { call } from 'redux-saga/effects';
import { whiteboardDrafts } from 'utils/whiteboard/drafts/WhiteboardDraftStore';
import { WhiteboardDraftAsset } from 'utils/whiteboard/drafts/types';
import { uploadWhiteboardImage } from 'utils/whiteboard/uploadWhiteboardImage';

// Whatever stops one upload of a restore usually stops all of them, and the same toast once per
// image is noise rather than information.
const RESTORE_UPLOAD_TOAST_ID = 'wb-restore-upload-failed';

export function* reseatRecordSaga(record: TLRecord, encryptionKey?: CryptoKey) {
  if (record.typeName !== 'asset') {
    return record;
  }

  // The draft store blanks only `data:` sources, which only an E2EE room produces; any other
  // source is still a live address.
  if (!encryptionKey && record.props.src !== '') {
    return record;
  }

  const stored: WhiteboardDraftAsset | undefined = yield call(
    whiteboardDrafts.readAsset,
    String(record.id)
  );

  if (!stored) {
    return null;
  }

  const file = new File([stored.data], stored.name || 'image', { type: stored.mimeType });
  const uploaded: { url: string } | undefined = yield call(uploadWhiteboardImage, file, {
    encryptionKey,
    toastId: RESTORE_UPLOAD_TOAST_ID,
  });

  if (!uploaded) {
    return null;
  }

  if (!encryptionKey) {
    return { ...record, props: { ...record.props, src: uploaded.url }, meta: {} } as TLRecord;
  }

  return { ...record, meta: { ...record.meta, src: uploaded.url } } as TLRecord;
}
